var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagEs = function SvgFlagEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-es_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flag-es_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB400",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-es_svg__c",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-es_svg__c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C51918",
    fillRule: "evenodd",
    d: "M0 0v3h16V0zM0 9v3h16V9z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M2.504 5.136h.56v2.912h-.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    fillRule: "evenodd",
    d: "M3.288 4.632H2.28v.28h.168v.224h.672v-.224h.168zM3.12 8.216h.168v.28H2.28v-.28h.168v-.224h.672z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    fillRule: "evenodd",
    d: "M2.784 4.688c.122 0 .134-.046.206-.114.056-.054.186-.12.186-.194 0-.17-.175-.308-.392-.308-.216 0-.392.138-.392.308 0 .083.09.138.157.194.072.058.124.114.235.114",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    fillRule: "evenodd",
    d: "M2.28 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-es_svg__d",
    width: 2,
    height: 1,
    x: 2,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.28 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056z",
    clipRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M7.992 5.136h.56v2.912h-.56z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    fillRule: "evenodd",
    d: "M8.776 4.632H7.768v.28h.168v.224h.672v-.224h.168zM8.608 8.216h.168v.28H7.768v-.28h.168v-.224h.672z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    fillRule: "evenodd",
    d: "M8.272 4.688c.122 0 .134-.046.206-.114.056-.054.186-.12.186-.194 0-.17-.175-.308-.392-.308-.216 0-.392.138-.392.308 0 .083.09.138.157.194.072.058.124.114.235.114",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    fillRule: "evenodd",
    d: "M7.768 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-es_svg__e",
    width: 2,
    height: 1,
    x: 7,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.768 8.496h1.008v.448s-.126-.056-.252-.056-.252.056-.252.056-.126-.056-.252-.056-.252.056-.252.056z",
    clipRule: "evenodd"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    fillRule: "evenodd",
    d: "M2.494 7.84c.101-.122.157-.234.157-.352a.3.3 0 0 0-.06-.192l.006-.003.15-.066c.072-.035.135-.072.197-.117.04-.028.092-.06.173-.103l.096-.051.096-.053c.085-.05.14-.09.183-.144a.268.268 0 0 0-.061-.399.7.7 0 0 0-.301-.096l-.197-.03q-.098-.015-.177-.03c.345-.057.836-.036 1.052.076l.206-.398c-.44-.228-1.445-.204-1.82.054-.275.19-.238.476.048.6.12.05.276.085.564.131a1 1 0 0 0-.126.081 1 1 0 0 1-.127.075l-.125.055-.017.008c-.233.106-.346.252-.312.517l.018.143.033.01zm-.288-.37v.002zm6.147.018c0 .118.056.23.157.352l.344-.284.033-.01.018-.143c.034-.265-.079-.411-.312-.517l-.016-.008-.125-.055a1 1 0 0 1-.128-.075 1 1 0 0 0-.126-.08c.289-.047.445-.081.564-.133.286-.123.323-.41.048-.6-.375-.257-1.379-.28-1.82-.053l.206.398c.216-.112.708-.133 1.052-.075l-.177.029-.196.03a.7.7 0 0 0-.301.096.268.268 0 0 0-.062.4.6.6 0 0 0 .183.143l.096.053.096.05c.081.044.134.076.173.104q.091.066.198.117l.15.066.006.003a.3.3 0 0 0-.061.192",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "m2.962 6.2.165.034v.247c-.176.14-.623.377-.623.377V6.2zM8.157 6.2l-.165.034v.247c.176.14.623.377.623.377V6.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    fillRule: "evenodd",
    d: "M7.388 3.603v-.082a1.53 1.53 0 0 0-.905-.31 1.8 1.8 0 0 0-.917-.157c-.466-.046-.935.157-.935.157-.473 0-.905.31-.905.31v.082l.565.567s.159.546 1.272.418v.001s.737-.02.79-.037l.063-.02c.144-.042.31-.09.407-.362zm-1.825-.519",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    fillRule: "evenodd",
    d: "m3.76 3.7.038-.042.513.483c.097-.026.626-.16 1.216-.168h.045a5.3 5.3 0 0 1 1.232.172s-.006.053-.021.116l.056-.11.006-.006.517-.487.038.041-.514.483c-.075.138-.112.23-.112.267 0 .058-.15.092-.444.128-.23.027-.5.046-.722.048h-.056a7 7 0 0 1-.722-.048c-.294-.036-.444-.07-.444-.128l-.004-.027a.4.4 0 0 1-.064-.154l-.044-.086zm2.867.75c.039.019.07 0 .095-.035l-.004.027-.015.007a1 1 0 0 1-.083.025 3 3 0 0 1-.296.047c-.238.029-.52.047-.744.049a7 7 0 0 1-.744-.049 3 3 0 0 1-.296-.047 1 1 0 0 1-.073-.02l.006-.003c.122-.058.93-.111 1.077-.12.145.009.954.062 1.077.12m.154-.01-.001.001",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    fillRule: "evenodd",
    d: "M5.556 2.674a.168.168 0 1 0 0-.336.168.168 0 0 0 0 .336",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    fillRule: "evenodd",
    d: "M5.493 2.038h.117v.074h.076v.117H5.61v.233h.076v.117h-.27v-.117h.077v-.233h-.077v-.117h.077z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    d: "M5.472 2.672h.224V3.4h-.224z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    d: "m3.854 3.648-.308-.011c.145-.839.86-1.25 2.002-1.25 1.144 0 1.856.413 1.99 1.255l-.415.043c-.066-.41-.752-.78-1.569-.78-.818 0-1.629.33-1.7.743"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E5E8",
    fillRule: "evenodd",
    d: "M3.736 4.632h3.64v3.27S7.106 9 5.556 9s-1.82-1.127-1.82-1.127z",
    clipRule: "evenodd",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag-es_svg__f",
    width: 5,
    height: 5,
    x: 3,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.736 4.632h3.64v3.27S7.106 9 5.556 9s-1.82-1.127-1.82-1.127z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag-es_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC034",
    d: "M3.736 6.648h1.848v2.184H3.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    d: "M3.736 4.576h1.848v2.128H3.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    d: "M5.528 6.592h1.848V8.72H5.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    d: "M5.528 4.632h1.96v2.072h-1.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F9FF",
    fillRule: "evenodd",
    d: "M6.741 8.721s-1.186.094-1.186-.671c0 0-.011.671-1.25.671v.604h2.436z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    fillRule: "evenodd",
    stroke: "#AD1619",
    strokeWidth: 0.583,
    d: "M5.556 7.096c.232 0 .42-.2.42-.448 0-.247-.188-.448-.42-.448s-.42.2-.42.448c0 .247.188.448.42.448Z",
    clipRule: "evenodd"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#C88A02",
    fillRule: "evenodd",
    d: "M4.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#C37C9C",
    fillRule: "evenodd",
    d: "M6.5 6a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC034",
    fillRule: "evenodd",
    d: "M6.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1619",
    d: "M4.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 11,
    x: 0.5,
    y: 0.5,
    stroke: "#000",
    strokeOpacity: 0.1,
    rx: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-es_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "#fff",
    rx: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "flag-es_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  })))));
};
export default SvgFlagEs;